import OrderContractSignatureRequired from '../../../../general-settings/enums/orderContractSignatureRequired.enum';
import { SignedContract } from '../../signed-contract';
import {
  GetValidContractParams,
  HasCurrentUserSignedParams,
  HasManualContractsParams,
  IsAutoSignEnabledParams,
  IsContractFullySignedParams,
  IsCurrentUserRequiredToSignParams,
  IsLastRequiredSignerParams,
} from './signedContracts.selectors.types';

export const isAutoSignEnabled = ({
  autoContractGeneration,
  orderContractSignatureRequired,
}: IsAutoSignEnabledParams): boolean =>
  !!autoContractGeneration &&
  orderContractSignatureRequired !== OrderContractSignatureRequired.BY_NONE;

export const getValidContract = ({
  signedContracts,
}: GetValidContractParams): SignedContract | null => signedContracts[0] ?? null;

export const hasManualContracts = ({ signedContracts }: HasManualContractsParams): boolean =>
  signedContracts.length > 1;

export const isCurrentUserRequiredToSign = ({
  isBrand,
  setting,
}: IsCurrentUserRequiredToSignParams): boolean => {
  return (
    (!isBrand && setting === OrderContractSignatureRequired.BY_STORE) ||
    setting === OrderContractSignatureRequired.BY_STORE_AND_BRAND
  );
};

export const isContractFullySigned = ({ contract }: IsContractFullySignedParams): boolean =>
  contract.userBrandSignedAt !== null && contract.userStoreSignedAt !== null;

export const hasCurrentUserSigned = ({ isBrand, contract }: HasCurrentUserSignedParams): boolean =>
  isBrand ? !!contract.userBrandSignedAt : !!contract.userStoreSignedAt;

export const isLastRequiredSigner = ({
  contract,
  signingAs,
  setting,
}: IsLastRequiredSignerParams): boolean => {
  const isBrand = signingAs === 'BRAND';
  const isStore = signingAs === 'STORE';
  if (setting === OrderContractSignatureRequired.BY_NONE) {
    return false;
  }
  if (setting === OrderContractSignatureRequired.BY_STORE) {
    return isStore;
  }
  if (isBrand) {
    return !!contract?.userStoreSignedAt;
  }
  if (isStore) {
    return !!contract?.userBrandSignedAt;
  }
  return false;
};
